/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import baseUrl from "../BaseUrl";
import Loader from "../Loader";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { formatUTCDate } from "../../utils/utils";
import ParticipationRate from "../ParticipationRate";
import { readSavedFilters, usePersistFilters } from "../../hooks/filterPersistence";

const STATE_KEY = "sleepSessionsState";

const UserSleepSessionCount = () => {

    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [popupOpen, setPopupOpen] = useState(false);
    const [users, setData] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);
    const [totalUserBase, setTotalUserBase] = useState(0);
    const [totalSessions, setTotalSessions] = useState(0);
    const [page, setPage] = useState(1);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [displayFromDate, setDisplayFromDate] = useState("");
    const [displayToDate, setDisplayToDate] = useState("");
    const [searchValue, setSearchValue] = useState('');
    const [sortField, setSortField] = useState('');
    const [sortOrder, setSortOrder] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        refreshToken();
        setName('Sleep Sessions');
    }, []);

    useEffect(() => {
        // Restore the list view on return from a drill-down (Back); else load all-time.
        const saved = readSavedFilters(STATE_KEY);
        if (saved) {
            setFromDate(saved.fromDate || ''); setToDate(saved.toDate || '');
            setDisplayFromDate(saved.fromDate ? new Date(saved.fromDate) : '');
            setDisplayToDate(saved.toDate ? new Date(saved.toDate) : '');
            setSearchValue(saved.searchValue || '');
            setSortField(saved.sortField || ''); setSortOrder(saved.sortOrder || '');
            setPage(saved.page || 1);
            getData(saved.page || 1, saved.fromDate || '', saved.toDate || '', saved.searchValue || '', saved.sortField || '', saved.sortOrder || '');
        } else {
            getData('1', '', '', '', '', '');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Snapshot filters so the exact view is restored on Back (remount).
    usePersistFilters(STATE_KEY, { fromDate, toDate, searchValue, sortField, sortOrder, page });

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/admin/api/token`);
            setToken(response.data.accessToken);
            const decoded = jwtDecode(response.data.accessToken);
            setExpire(decoded.exp);
        } catch (error) {
            console.log(error.response);
            if (error.response) {
                navigate("/");
                window.location.reload();
            }
        }
    };

    const axiosJWT = axios.create();

    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/admin/api/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwtDecode(response.data.accessToken);
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const getData = async (page, fromDate, toDate, search, sortField, sortOrder) => {
        setPopupOpen(true);
        const response = await axiosJWT.get(
            `${baseUrl}/admin/api/user-sleep-sessions?page=${page}&limit=20&from_date=${fromDate}&to_date=${toDate}&search=${search}&sortField=${sortField}&sortOrder=${sortOrder}`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        setPopupOpen(false);
        setData(response.data.data);
        setTotalItem(response.data.totalItem);
        setTotalUsers(response.data.totalUsers || 0);
        setTotalUserBase(response.data.totalUserCount || 0);
        setTotalSessions(response.data.totalSessions || 0);
    };

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
        getData(pageNumber, fromDate, toDate, searchValue, sortField, sortOrder);
    };

    const handleFromDate = (date) => {
        if (!date) { setFromDate(''); setDisplayFromDate(''); return; }
        const formattedDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
        setFromDate(formattedDate);
        setDisplayFromDate(date);
    };

    const handleToDate = (date) => {
        if (!date) { setToDate(''); setDisplayToDate(''); return; }
        const formattedDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
        setToDate(formattedDate);
        setDisplayToDate(date);
    };

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleSearchSubmit = () => {
        setPage(1);
        getData(1, fromDate, toDate, searchValue, sortField, sortOrder);
    };

    const clearFilter = () => {
        setFromDate('');
        setDisplayFromDate('');
        setToDate('');
        setDisplayToDate('');
        setSearchValue('');
        setSortField('');
        setSortOrder('');
        setPage(1);
        getData(1, '', '', '', '', '');
    };

    const handleSort = (field) => {
        const order = sortField === field && sortOrder === "ASC" ? "DESC" : "ASC";
        setSortField(field);
        setSortOrder(order);
        setPage(1);
        getData(1, fromDate, toDate, searchValue, field, order);
    };

    const sortIcon = (field) => sortField === field ? (sortOrder === "ASC" ? "🔼" : "🔽") : "";

    return (
        <div className="panelbox">
            <Navbar />
            <div className="right-panel">
                <Header name={name} />
                {popupOpen && <Loader />}
                <div className="content-page">
                    <div className="row">
                        <div className="col-6">
                            <div className="left-title">
                                <h1>Sleep Sessions</h1>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="addnew-button">
                                <Link to="/dashboard"><span>&larr;</span> Back</Link>
                            </div>
                        </div>
                    </div>

                    <div className="row numberboxes">
                        <div className="col-md-3">
                            <div className="dashboard-box" id="number">
                                <h3>Total Users</h3>
                                <p>{totalUsers}</p>
                                <ParticipationRate count={totalUsers} total={totalUserBase} />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="dashboard-box" id="number">
                                <h3>Total Sessions</h3>
                                <p>{totalSessions}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 order-filter transection-filter">
                            <div className="boxinput">
                                <input
                                    className="search-leave satff-listing-page-search"
                                    type="text"
                                    name="search"
                                    placeholder="Search by name or email"
                                    value={searchValue}
                                    onChange={handleSearchChange}
                                />
                                <DatePicker
                                    selected={displayFromDate}
                                    onChange={handleFromDate}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="From Date"
                                    className="from-date"
                                />
                                <DatePicker
                                    selected={displayToDate}
                                    onChange={handleToDate}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="To Date"
                                    className="end-date"
                                />
                                <button className="search-btn" onClick={handleSearchSubmit}>Search</button>
                                {(fromDate || toDate || searchValue) && (
                                    <button type="button" className="search-btn clear-btn" onClick={clearFilter}>Clear</button>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="fullwidth-table track-table-body staff-listing-admin-table-body">
                                <table className="table is-striped is-fullwidth">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>UUID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Country</th>
                                            <th>App Version</th>
                                            <th>Subscription</th>
                                            <th style={{ cursor: 'pointer' }} onClick={() => handleSort("session_count")}>
                                                Session Count {sortIcon("session_count")}
                                            </th>
                                            <th style={{ cursor: 'pointer' }} onClick={() => handleSort("created_time_stamp")}>
                                                Created {sortIcon("created_time_stamp")}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users && users.map((row, index) => (
                                            <tr key={`${row.uuid}-${row.id}-${index}`}>
                                                <td data-label="No">{(page - 1) * 20 + index + 1}</td>
                                                <td data-label="UUID" style={{ maxWidth: '160px', wordBreak: 'break-all', fontSize: '12px' }}>{row.uuid}</td>
                                                <td data-label="Name">{row.name}</td>
                                                <td data-label="Email">{row.email}</td>
                                                <td data-label="Country">{row.country}</td>
                                                <td data-label="App Version">{row.mobile_app_version}</td>
                                                <td data-label="Subscription">{row.subscription_status}</td>
                                                <td data-label="Session Count">
                                                    <Link to={`/sleep-session-details/${btoa(row.uuid)}/${btoa(row.id)}`}>
                                                        {row.session_count}
                                                    </Link>
                                                </td>
                                                <td data-label="Created">{formatUTCDate(row.created_time_stamp)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {totalItem > 20 && (
                                    <Pagination
                                        activePage={page}
                                        itemsCountPerPage={20}
                                        totalItemsCount={totalItem}
                                        pageRangeDisplayed={5}
                                        onChange={handlePageChange.bind(this)}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserSleepSessionCount;
